module.exports = __webpack_public_path__ + "img/KCS.ec89da3c.svg";